import {
  addDoc, collection, deleteDoc, doc, onSnapshot, orderBy, query, Timestamp, updateDoc,
} from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { logListenerError } from '../db';

// Admin collections whose records carry createdAt/updatedAt (issues, feedback).

const withDates = (snap) => {
  const data = snap.data();
  return {
    id: snap.id,
    ...data,
    createdAt: data.createdAt?.toDate?.() || new Date(),
    updatedAt: data.updatedAt?.toDate?.() || new Date(),
  };
};

export function trackedCollection(name) {
  const records = () => collection(db, name);
  const recordRef = (id) => doc(db, name, id);
  return {
    /** Newest first, with createdAt/updatedAt as Dates. */
    subscribe(onChange, onError = logListenerError(name)) {
      return onSnapshot(query(records(), orderBy('createdAt', 'desc')),
        (snapshot) => onChange(snapshot.docs.map(withDates)), onError);
    },
    async create(data) {
      const now = Timestamp.now();
      const ref = await addDoc(records(), { ...data, createdAt: now, updatedAt: now });
      return ref.id;
    },
    update(id, data) {
      return updateDoc(recordRef(id), { ...data, updatedAt: Timestamp.now() });
    },
    remove(id) {
      return deleteDoc(recordRef(id));
    },
  };
}
